import { React, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { useLanguage } from '../../../Context/LanguageContext';
import TotalModalWrapper from '../../Share/Normal/TotalModalWrapper';
import LockerCountInput from '../../../Component/LockerComponent/LockerCountInput';
import LockerDivisionSelectBox from '../../../Component/LockerComponent/LockerDivisionSelectBox';

const LockerAddModal = forwardRef((props, ref) => {
  const { lockerDivisions, selectedAddLockerDivision, setSelectedAddLockerDivision, exitClick, saveClick } = props;
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t } = useLanguage();

  const InputRef = useRef();

  useImperativeHandle(ref, () => ({
		getValue: () => {
      return InputRef.current.getValue();
    }
	}));

  return (
    <TotalModalWrapper>
      <ModalView $isDark={isDark}>
        <TotalWrapper>
        <Title>{t('main.locker.add.title')}</Title>
        <SelectBoxWrapper>
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} cursor='default'>{t('main.locker.add.division')}</Text>
          <LockerDivisionSelectBox 
            options={lockerDivisions} 
            defaultVal={selectedAddLockerDivision}
            setDefaultVal={setSelectedAddLockerDivision}/>
        </SelectBoxWrapper>
        <LockerCountInput ref={InputRef}/>
        <ButtonWrapper>
          <ExitButton onClick={exitClick}>{t('main.locker.cancel')}</ExitButton>
          <SaveButton onClick={saveClick}>{t('main.locker.save')}</SaveButton>
        </ButtonWrapper>
        </TotalWrapper>
      </ModalView>
    </TotalModalWrapper>
  )
})

export default LockerAddModal;

const ModalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 266px;
  // height: 228px;
  height: 278px;

  border-radius: 10px;
  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(0, 0, 0, 0.1)'};
  background-color: ${props => props.theme.subBackground};
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;
`;

const SelectBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  margin-top: 16px;

	width: 210px;

  gap: 8px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 36px;

  width: 100%;
  
  gap: 16px;
  // margin-left: 20px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.buttonFill};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.text};

  transition: all 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const SaveButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: ${props => props.theme.subKey};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.subKeyHover};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;
